// Path: ./src/app/components/LanguageGroupButton/styled.ts
import styled from "styled-components";

export const ButtonGroup = styled.div`
  display: flex;
  align-items: center;
`;

export const LeftButton = styled.button`
  background: ${(props: { active: boolean }) =>
    props.active
      ? "#c5c5c5 0% 0% no-repeat padding-box"
      : "0% 0% no-repeat padding-box padding-box rgb(255 255 255 / 96%)"};
  box-shadow: ${(props: { active: boolean }) =>
    props.active ? "none" : "#0000000f 4px 4px 31px -13px"};
  border-radius: 10px 0px 0px 10px;
  opacity: 1;
  width: 70px;
  height: 37px;
  cursor: pointer;
  border: 0px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
`;
export const RightButton = styled.button`
  background: ${(props: { active: boolean }) =>
    props.active
      ? "0% 0% no-repeat padding-box padding-box rgb(255 255 255 / 96%)"
      : "#c5c5c5 0% 0% no-repeat padding-box"};

  box-shadow: ${(props: { active: boolean }) =>
    props.active ? "#0000000f 4px 4px 31px -13px" : "none"};
  border: 0px;
  border-radius: 0px 10px 10px 0px;
  opacity: 1;
  width: 70px;
  height: 37px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
`;

export const ButtonText = styled.span`
  font-size: 13px;
`;
